import React from 'react';
import './RogueOperator.css';
import { useOperatorContext } from '../../login/OperatorContextProvider';

const RogueOperator = () => {
  const {operator} = useOperatorContext(); // , operatorState, isOperatorReady, landed, setLanded
  //const {navToDefaultPage}                    = useKiponosNavigator();

    // useEffect(()=>{
    //   if (isOperatorReady() && !landed) {
    //     navToDefaultPage();
    //     setLanded(true);
    //   }
    // }, [operatorState, isOperatorReady, navToDefaultPage, landed, setLanded]);

  return (
    <div className='rogueOperator'>
      <div className='rogueData'>
        Operator: {operator?.username}
      </div>
    </div>
  );
};

export default RogueOperator;